/** @format */

import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
import { Typography } from '@material-ui/core';
import I18n from '../Translate/I18n';
import { LegendMapInt18n } from '../../views/Provisioning/view/BlockViewStateType';
import green from '@material-ui/core/colors/green';
import { brown, lime } from '@material-ui/core/colors';
import amber from '@material-ui/core/colors/amber';
import deepOrange from '@material-ui/core/colors/deepOrange';
import React from 'react';
import oplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

interface TableLegendProps {
    elements: Array<{ color: string; borderColor: string; label: string }>;
}

const TableLegend = (props: TableLegendProps): React.ReactElement => {
    return (
        <GridContainer style={{ width: 500, margin: 15 }}>
            <GridItem xs={12}>
                <Typography variant="subtitle2">
                    <I18n trans="prov:list.legend" />
                </Typography>
            </GridItem>
            {props.elements &&
                props.elements.map((el: { color: string; borderColor: string; label: string }) => {
                    return (
                        <>
                            <GridItem xs={2} style={{ border: `1px solid ${el.borderColor}`, backgroundColor: el.color }} />
                            <GridItem xs={10}>
                                <I18n trans={el.label} />
                            </GridItem>
                        </>
                    );
                })}
        </GridContainer>
        //     <GridItem xs={12}>
        //         <Typography variant="subtitle2">
        //             <I18n trans="prov:list.legend" />
        //         </Typography>
        //     </GridItem>
        //     <GridItem xs={2} style={{ border: '1px solid #a1a1a1' }} />
        //     <GridItem xs={10}>
        //         <I18n trans={LegendMapInt18n.FINISH} />
        //     </GridItem>
        //     <GridItem xs={2} style={{ backgroundColor: green[700] }} />
        //     <GridItem xs={10}>
        //         <I18n trans={LegendMapInt18n.IN_PROGRESS} />
        //     </GridItem>
        //     <GridItem xs={1} style={{ backgroundColor: lime[700] }} />
        //     <GridItem xs={11}>
        //         <I18n trans={LegendMapInt18n.CALL_SUB_BLOCK} />
        //     </GridItem>
        //     <GridItem xs={1} style={{ backgroundColor: amber['A700'] }} />
        //     <GridItem xs={11}>
        //         <I18n trans={LegendMapInt18n.CANCELED} />
        //     </GridItem>
        //     <GridItem xs={1} style={{ backgroundColor: deepOrange[300] }} />
        //     <GridItem xs={11}>
        //         <I18n trans={LegendMapInt18n.ERROR} />
        //     </GridItem>
        //     <GridItem xs={1} style={{ backgroundColor: brown[100] }} />
        //     <GridItem xs={11}>
        //         <I18n trans={LegendMapInt18n.RENEWAL} />
        //     </GridItem>
        // </GridContainer>
    );
};

export default TableLegend;
